export * from './lib/standalone.module';
